<template>
    <!-- 底部网站信息描述 -->
    <div class="footer">
        <div class="footer-cont">
            <div class="sec-row-control logo-container">
                <div class="logo-cont"  @click="_handleBackHome">
                    <img class="img" src="@/assets/images/home/footer_logo.png" />
                    <div>Charm</div>
                </div>
            </div>

            <div class="sec-row-control other-container">
                <div class="row-section-cont">
                    <div class="sec-item-cont about-us">
                        <div class="title">About us</div>
                        <div class="about-item" @click="_goTOPrecdureIndex">
                            Procedures
                        </div>
                        <div class="about-item" @click="_goToDoctorIndex">
                            Doctors
                        </div>
                    </div>
                    <div class="sec-item-cont contact-us">
                        <div class="title" @click="goContactUs">Contact Us</div>
                        <div class="contact-item">
                            <!-- <n-icon size="18"><img src="@/assets/icons/icon_address.svg" /></n-icon> -->
                            <div>9100 Wilshire Blvd, Beverly hills, CA 90212</div>
                        </div>
                        <div class="contact-item">
                            <!-- <n-icon size="18"><img src="@/assets/icons/icon_email_plain.svg" /></n-icon> -->
                            <div>support@charm-vibe.com</div>
                        </div>
                    </div>
                </div>
                <div class="row-section-cont">
                    <div class="follow-us">
                        <div class="title">Follow Us</div>
                        <div class="icon-cont">
                            <!-- <div>
                                <a  href="javascript:void(0)" target="_blank"><img src="@/assets/icons/icon_facebook_lineout.svg" /></a>
                            </div> -->
                            <div>
                                <a href="https://www.instagram.com/charmvibeofficial/" target="_blank"><img src="@/assets/icons/icon_instagram_new.svg" /></a>
                            </div>
                            <div>
                                <a  href="https://www.tiktok.com/@charmvibelv" target="_blank"><img src="@/assets/icons/icon_tiktok_new.svg" /></a>
                            </div>
                            <div>
                                <a href="https://www.linkedin.com/company/charm-vibe/" target="_blank"><img src="@/assets/icons/icon_linkedin_blue_new.svg" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="sec-row-control site-container">
                <div class="row-section-cont">
                    <a href="/termsservice" target="_blank" class="text-item">Website Terms</a>
                    <a href="/privacypolicy" target="_blank" class="text-item">Privacy Policy</a>
                    <span class="text-item">Accessibility Statement</span>
                    <span class="text-item">AHPRA Advertising Disclaimer</span>
                    <span class="text-item">Supplier Code of Conduct</span>
                </div>
                <div class="row-section-cont">
                    <span class="text-item">Cookie Preferences</span>
                    <span class="text-item">Do Not Sell My Personal Information</span>
                    <span class="text-item">Modern Slavery Statement</span>
                </div>
                <div class="row-section-cont">
                    <span class="text-item">Charm-Vibe™ — Empowering Confidence. Supporting Communities.</span>
                </div>
                <div class="row-section-cont">
                    <span class="text-item">© {{curYear}} Charm-Vibe. All Rights Reserved.</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router";

const router = useRouter();

const curYear = new Date().getFullYear();

const _goTOPrecdureIndex = () => {
    router.push({ path: "/procedure" });
};

const _goToDoctorIndex = () => {
    router.push({ path: "/doctor" });
};

const goContactUs = () => {
    router.push({ path: "/contactUs" });
};

const _handleBackHome = () => {
    if (router.currentRoute.value.name === "Home") {
        return;
    }
    router.push({ path: "/" });
};
</script>

<style lang="scss" scoped>
.footer {
    padding: 80px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    background-color: #0f0f0f;
    color: #c1c1c1;

    .footer-cont {
        width: 100%;

        .sec-row-control{
            width: 100%;

            .row-section-cont{
                display: flex;
                flex: 1 1 auto;
            }

            .logo-cont {
                display: flex;
                flex: 1;
                justify-content: flex-start;
                align-items: center;
                cursor: pointer;

                .img {
                    width: 80px;
                    height: 80px;
                }

                div {
                    margin-left: 16px;
                    color: #FFFFFF;
                    font-family: "Oleo Script Swash Caps Regular";
                    font-size: 32px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                }
            }
        }



        .other-container {
            display: flex;
            width: calc(100% - 88px);
            margin-left: 88px;
            padding: 40px 0 32px 0;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            .about-us {
                color: #FFF;
                font-family: "Helvetica Neue";
                font-style: normal;
                line-height: normal;

                .title {
                    margin-bottom: 20px;
                    font-size: 24px;
                    font-weight: 500;
                }

                .about-item {
                    color: #FFF;
                    font-size: 18px;
                    font-weight: 400;
                    line-height: 180%; /* 32.4px */
                    cursor: pointer;
                }
            }

            .contact-us {
                margin-left: 100px;
                color: #FFF;
                font-family: "Helvetica Neue";
                font-style: normal;
                line-height: normal;

                .title {
                    margin-bottom: 20px;
                    font-size: 24px;
                    font-weight: 500;
                }

                .contact-item {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;

                    cursor: pointer;

                    img {
                        width: 18px;
                        height: 18px;
                    }

                    div {
                        margin-left: 2px;
                        color: #FFF;
                        font-size: 18px;
                        font-weight: 400;
                        line-height: 180%; /* 32.4px */
                    }
                }
            }

            .follow-us {
                color: #FFF;
                font-family: "Helvetica Neue";
                font-style: normal;
                line-height: normal;

                .title {
                    margin-bottom: 20px;
                    font-size: 24px;
                    font-weight: 500;
                }

                .icon-cont {
                    display: flex;
                    margin-top: 20px;
                    height: 40px;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    gap: 60px;

                    img {
                        width: 40px;
                        height: 40px;
                    }
                }
            }
        }

        .site-container{
            width: calc(100% - 88px);
            margin-left: 88px;
            padding-top: 20px;
            border-top: 1px solid rgba(255, 255, 255, 0.25);

            .row-section-cont{
                display: flex;
                padding: 12px 0 0 0;
                gap: 16px;
                align-items: center;
                justify-content: flex-start;
                flex-wrap: wrap;

                .text-item{
                    color: #FFF;
                    font-family: "Helvetica Neue";
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 150%; /* 24px */
                    opacity: 0.7; 
                }
            }
        }
    }
}
@media screen and (max-width: 1024px) and (min-width: 744px) {
    .footer {
        padding: 20px;

        .footer-cont {
            .sec-row-control{
                .logo-cont {
                    .img {
                        width: 60px;
                        height: 60px;
                    }

                    div {
                        margin-left: 12px;
                        font-size: 24px;
                    }
                }
            }



            .other-container {
                display: flex;
                width: calc(100% - 60px);
                margin-left: 60px;
                padding: 20px 0 16px 0;
                gap: 20px;

                .about-us {
                    .title {
                        min-width: 100px;
                        margin-bottom: 12px;
                        font-size: 20px;
                    }

                    .about-item {
                        font-size: 14px;
                    }
                }

                .contact-us {
                    margin-left: 16px;

                    .title {
                        margin-bottom: 12px;
                        font-size: 20px;
                    }

                    .contact-item {
                        div {
                            margin-left: 2px;
                            font-size: 14px;
                        }
                    }
                }

                .follow-us {

                    .title {
                        margin-bottom: 12px;
                        font-size: 20px;
                    }

                    .icon-cont {
                        display: flex;
                        margin-top: 20px;
                        height: 40px;
                        gap: 20px;

                        img {
                            width: 40px;
                            height: 40px;
                        }
                    }
                }
            }

            .site-container{
                width: calc(100% - 60px);
                margin-left: 60px;
                padding-top: 10px;
                border-top: 1px solid rgba(255, 255, 255, 0.25);

                .row-section-cont{
                    padding: 12px 0 0 0;
                    gap: 12px;

                    .text-item{
                        font-size: 14px;
                        line-height: 140%; 
                    }
                }
            }
        }
    }
}

@media screen and (max-width: 744px) {
    .footer {
        padding: 20px;

        .footer-cont {
            .sec-row-control{
                .logo-cont {
                    .img {
                        width: 60px;
                        height: 60px;
                    }

                    div {
                        margin-left: 12px;
                        font-size: 24px;
                    }
                }
            }



            .other-container {
                display: flex;
                width: calc(100% - 60px);
                margin-left: 60px;
                padding: 20px 0 16px 0;
                flex-direction: column;
                align-items: flex-start;
                gap: 20px;

                .about-us {
                    .title {
                        min-width: 85px;
                        margin-bottom: 12px;
                        font-size: 16px;
                    }

                    .about-item {
                        font-size: 12px;
                    }
                }

                .contact-us {
                    margin-left: 16px;

                    .title {
                        margin-bottom: 12px;
                        font-size: 16px;
                    }

                    .contact-item {
                        div {
                            margin-left: 2px;
                            font-size: 12px;
                        }
                    }
                }

                .follow-us {

                    .title {
                        margin-bottom: 12px;
                        font-size: 16px;
                    }

                    .icon-cont {
                        display: flex;
                        margin-top: 20px;
                        height: 40px;
                        gap: 20px;

                        img {
                            width: 40px;
                            height: 40px;
                        }
                    }
                }
            }

            .site-container{
                width: calc(100% - 60px);
                margin-left: 60px;
                padding-top: 10px;
                border-top: 1px solid rgba(255, 255, 255, 0.25);

                .row-section-cont{
                    padding: 12px 0 0 0;
                    gap: 12px;

                    .text-item{
                        font-size: 12px;
                        line-height: 120%; 
                    }
                }
            }
        }
    }
}
</style>
